import { useAuthStore } from '../stores/authStore';
import { ADMIN_ROLES } from '../lib/constants';

export function usePermissions() {
  const adminUser = useAuthStore((s) => s.adminUser);
  const role = adminUser?.admin_role;

  return {
    role,
    isSuperAdmin: role === ADMIN_ROLES.SUPER_ADMIN,
    isFinanceAdmin: role === ADMIN_ROLES.FINANCE_ADMIN,
    isSupportAgent: role === ADMIN_ROLES.SUPPORT_AGENT,
    canManageSubscriptions: role === ADMIN_ROLES.SUPER_ADMIN || role === ADMIN_ROLES.FINANCE_ADMIN,
    canManageFeatureFlags: role === ADMIN_ROLES.SUPER_ADMIN,
    canImpersonate: role === ADMIN_ROLES.SUPER_ADMIN || role === ADMIN_ROLES.SUPPORT_AGENT,
    canDeleteUsers: role === ADMIN_ROLES.SUPER_ADMIN,
    hasRole: (roles: string[]) => !!role && roles.includes(role),
  };
}
